import { useContext, useEffect, useState } from "react";
import { Table, Card, Tooltip } from "antd";

import { Context } from "../../context";
import { Fetch } from "../../fetch";

import "./styles.css";
import { InfoCircleTwoTone } from "@ant-design/icons";

const { Column } = Table;

const EngagementMetrics = () => {
  const { token, apiUrl } = useContext(Context);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [lastMonths, _] = useState(6);

  useEffect(() => {
    setLoading(true);
    Fetch(
      `${apiUrl}/reports/engagement_reports?last=${lastMonths}`,
      token,
      (result) => {
        if (result) {
          setColumns(result.columns);
          setData(result.data);
          setLoading(false);
          setRefresh(false);
        } else {
          setLoading(false);
          setRefresh(false);
        }
      }
    );
  }, [apiUrl, token, refresh]);

  return (
    <Card
      className="reports-wrapper"
      title={`Engagement Metrics`}
      extra={
        <Tooltip title="Watch times are displayed in minutes">
          <InfoCircleTwoTone style={{ fontSize: "2em" }} />
        </Tooltip>
      }
    >
      {(columns && columns.length === 0) || (data && data.length) === 0 ? (
        <div>Data unavailable at this moment, please try after sometime.</div>
      ) : (
        <Table
          dataSource={data}
          size="small"
          bordered={true}
          pagination={false}
          style={{ border: "3px", background: "white" }}
          loading={loading}
        >
          {columns &&
            columns.map((mo) => (
              <Column
                title={
                  mo.name
                    ? `${mo.name.split("::")[0].substring(0, 3)} (${mo.name
                        .split("::")
                        .pop()})`
                    : "Metrics"
                }
                dataIndex={mo.dataIndex}
                key={mo.name ? mo.name : "metrics"}
                align={mo.align}
                width={!mo.name && "10%"}
              />
            ))}
        </Table>
      )}
    </Card>
  );
};

export default EngagementMetrics;
